import type { ModalHeaderProps } from './ModalHeader.types';
import type { ReactElement } from 'react';

import { Flex, IconButton, Text } from '@rango-dev/whale';
import { ChevronLeft, X } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ICON_SIZE = 16;

export function ModalHeader(props: ModalHeaderProps): ReactElement {
  const { t } = useTranslation();

  /*
   * Three-slot header: the two side slots grow equally (flex-basis 0), so the
   * title stays centered across the FULL container width regardless of which
   * button is present — the empty slot reserves the same space the back/close
   * button occupies on the other side.
   */
  return (
    <Flex align="center" gap="2" px="4" height="var(--space-9)" flexShrink="0">
      <Flex flexGrow="1" flexBasis="0" minWidth="0" justify="start">
        {props.showBackButton && (
          <IconButton
            id="back-connect-wallet-btn"
            type="button"
            variant="ghost"
            size="2"
            color="gray"
            radius="full"
            aria-label={t('Back')}
            onClick={props.onClose}>
            <ChevronLeft size={ICON_SIZE} aria-hidden />
          </IconButton>
        )}
      </Flex>

      <Text size="5" weight="bold" align="center" truncate>
        {props.title}
      </Text>

      <Flex flexGrow="1" flexBasis="0" minWidth="0" justify="end">
        {!props.showBackButton && (
          <IconButton
            id="close-connect-wallet-btn"
            type="button"
            variant="ghost"
            size="2"
            color="gray"
            radius="full"
            aria-label={t('Close')}
            onClick={props.onClose}>
            <X size={ICON_SIZE} aria-hidden />
          </IconButton>
        )}
      </Flex>
    </Flex>
  );
}
